module.exports = __webpack_public_path__ + "assets/images/logo@2x.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/images/logo@2x.png
 ** module id = 301
 ** module chunks = 0
 **/